import { render } from "./CreateVpc.vue?vue&type=template&id=0b25102d&scoped=true"
import script from "./CreateVpc.vue?vue&type=script&lang=js"
export * from "./CreateVpc.vue?vue&type=script&lang=js"

import "./CreateVpc.vue?vue&type=style&index=0&id=0b25102d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b25102d"]])

export default __exports__